module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [(_vm.step == 1) ? _c('div', {
    staticClass: "main-box"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "125px",
      "model": _vm.formCustom
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专辑名称: ",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.formCustom.albumName),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "albumName", $$v)
      },
      expression: "formCustom.albumName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出版社: ",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.formCustom.albumPublisher),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "albumPublisher", $$v)
      },
      expression: "formCustom.albumPublisher"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专辑封面: ",
      "label-width": "120px"
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [(_vm.formCustom.img_large != '') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.formCustom.img_large,
      "width": "80px",
      "height": "80px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Upload', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "action": "/aries-api/resource/upload",
      "type": "drag",
      "accept": "image/jpeg, image/gif, image/png",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUpload,
      "data": _vm.uploadData,
      "show-upload-list": false,
      "disabled": _vm.doWhatTemp === 'view'
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload",
      "size": "32",
      "color": "#3399ff"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联绘本: ",
      "label-width": "120px"
    }
  }, [_c('AddPictureBook', {
    attrs: {
      "doWhatTemp": _vm.doWhatTemp,
      "currCpId": _vm.currCpId,
      "isSystem": _vm.isSystem
    },
    on: {
      "resourseSel": _vm.handleResAdd
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "词汇量: ",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.formCustom.readCount),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "readCount", _vm._n($$v))
      },
      expression: "formCustom.readCount"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专辑描述: ",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "rows": 5,
      "type": "textarea",
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.formCustom.description),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "description", $$v)
      },
      expression: "formCustom.description"
    }
  })], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doNextStep('formCustom')
      }
    }
  }, [_vm._v("下一步")])], 1) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('div', {
    staticClass: "main-box"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "125px",
      "model": _vm.formCustom
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专辑名称: ",
      "label-width": "120px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.formCustom.albumName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出版社: ",
      "label-width": "120px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.formCustom.albumPublisher))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专辑封面: ",
      "label-width": "120px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.formCustom.img_large,
      "width": "80px",
      "height": "80px"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联绘本: ",
      "label-width": "120px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formCustom.res,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rid",
      "label": "ID",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "资源名称",
      "align": "center",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序",
      "align": "center",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('InputNumber', {
          attrs: {
            "size": "small",
            "min": 1,
            "disabled": _vm.doWhatTemp === 'view'
          },
          on: {
            "on-change": function (value) { return _vm.handleNumberChange(value, scope.row, scope.$index); }
          },
          model: {
            value: (scope.row.ind),
            callback: function($$v) {
              _vm.$set(scope.row, "ind", $$v)
            },
            expression: "scope.row.ind"
          }
        })]
      }
    }], null, false, 1158262076)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clevel",
      "label": "上下架状态",
      "width": "140",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.clevel == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已下架")]) : (scope.row.clevel == 4) ? _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("审核通过")]) : (scope.row.clevel == 5) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : (scope.row.clevel == 2) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("编辑中")]) : _vm._e()]
      }
    }], null, false, 1547265750)
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": _vm.delResItem
    }
  }, [_vm._v("删除资源")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('AddPictureBook', {
    attrs: {
      "doWhatTemp": _vm.doWhatTemp,
      "currCpId": _vm.currCpId,
      "styleShow": "btn",
      "isSystem": _vm.isSystem
    },
    on: {
      "resourseSel": _vm.handleResAdd2Server
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doLastStep
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "150px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": _vm.finishEdit
    }
  }, [_vm._v("完成")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55c78d73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/addAlbum.vue
// module id = 694
// module chunks = 1